import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useTranslation } from 'react-i18next';

export interface DashboardFilterValues {
  subscriptionType: string;
  dateFrom: string;
  dateTo: string;
  category: string;
}

interface Props {
  filters: DashboardFilterValues;
  onChange: (filters: DashboardFilterValues) => void;
  onReset: () => void;
  categories: { id: string; name: string }[];
}

export default function DashboardFilters({
  filters,
  onChange,
  onReset,
  categories,
}: Props) {
  const { t } = useTranslation();
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  const update = (key: keyof DashboardFilterValues, value: string) => {
    onChange({ ...filters, [key]: value });
  };

  return (
    <Card p="16px" w="100%">
      <Flex gap="12px" wrap="wrap" align="flex-end">
        <FormControl minW="150px" flex="1">
          <FormLabel fontSize="xs" color="gray.500" mb="4px">
            {t('dashboard.status') || 'Status'}
          </FormLabel>
          <Select
            size="sm"
            borderRadius="8px"
            value={filters.subscriptionType}
            onChange={(e) => update('subscriptionType', e.target.value)}
          >
            <option value="">All</option>
            <option value="active">Active</option>
            <option value="trial">Trial</option>
            <option value="cancelled">Cancelled</option>
            <option value="expired">Expired</option>
            <option value="pending">Pending</option>
            <option value="trial_expired">Trial Expired</option>
          </Select>
        </FormControl>

        <FormControl minW="150px" flex="1">
          <FormLabel fontSize="xs" color="gray.500" mb="4px">
            Category
          </FormLabel>
          <Select
            size="sm"
            borderRadius="8px"
            value={filters.category}
            onChange={(e) => update('category', e.target.value)}
          >
            <option value="">All</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl minW="140px" flex="1">
          <FormLabel fontSize="xs" color="gray.500" mb="4px">
            From
          </FormLabel>
          <Input
            type="date"
            size="sm"
            borderRadius="8px"
            value={filters.dateFrom}
            onChange={(e) => update('dateFrom', e.target.value)}
          />
        </FormControl>

        <FormControl minW="140px" flex="1">
          <FormLabel fontSize="xs" color="gray.500" mb="4px">
            To
          </FormLabel>
          <Input
            type="date"
            size="sm"
            borderRadius="8px"
            value={filters.dateTo}
            onChange={(e) => update('dateTo', e.target.value)}
          />
        </FormControl>

        <Button
          size="sm"
          variant="outline"
          colorScheme="gray"
          borderRadius="8px"
          onClick={onReset}
          minW="70px"
        >
          Reset
        </Button>
      </Flex>
    </Card>
  );
}
